import AppConstants from '../../config/app.constants';

class ATMCodesManagementController {

    /*@ngInject*/
    constructor($state, $q, $translate, User, RouteService, Modal, DateUtil, BranchService, SetupService, Sound, AtmCodesManagementService, $rootScope, DataCounter, Navigation) {
        this.$q = $q;
        this.$translate = $translate;
        this.User = User;
        this.Modal = Modal;
        this.DateUtil = DateUtil;
        this.SetupService = SetupService;
        this.Sound = Sound;
        this.$state = $state;
        this.AtmCodesManagementService = AtmCodesManagementService;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Navigation = Navigation;

        this.model = {
            messenger: '',
            keyNumber: '',
            date: '',
            route: '',
            day: '',
            selectedDay: 'Mon',
            kabaKey: '',
            SGKey: '',
            // atmCode,
            branch: this.User.getUser().branchId,
            firstName: this.User.getUser().firstName,
            lastName: this.User.getUser().lastName,
            allRoutes: [],
            totalRecords: '',
            loggedInUser: User.getUser().id,
            routeSequence: [],
            messengerId: '',
            stats: 'manual',
            routeList: [],
            routeStatus: "",
            isDisabled: true,
            routeKeyId: ''
        }

        this.isEdit = false;
        this.$rootScope.$broadcast('routeChange', '/app/atm-codes-management');
        this.vaultDateRoutes = [];
        this.atmCodesData = "";
        this.isAutoOpenATMs = false;
        this.isLoadingRoutes = false;
        this.reassignLockObj = {};
    }

    focuseElementById(id) {
        setTimeout(() => {
            document.getElementById(id).focus()
        }, 300);
    }

    $onInit() {
        this.$q.all([
            this.SetupService.get(this.model.branch)
        ])
            .then((data) => {
                clearInterval(this.apiCallTimer);
                this.model.date = this.DateUtil.convertToDate(data[0].currentVaultDate);
                this.minVaultDate = {
                    minDate: this.model.date,
                    maxDate: moment(this.model.date).add(1, 'days').toDate()
                }
            })
            .then(() => {
                this.allRoutes()
                    .then(() => {
                        this.getDataFromCheckoutScreen();
                    })
            })
    }

    getDataFromCheckoutScreen() {
        this.atmCodesData = this.DataCounter.getAtmCodeData();
        if (this.atmCodesData && this.atmCodesData.redirectFromCheckoutScreen) {
            this.model.date = this.atmCodesData.vaultDate;
            let route = _.find(this.model.routeList, { routeId: this.atmCodesData.routeId.toUpperCase() })
            if (route) {
                this.model.route = { Key: route.routeId + " | " + route.routeName, Value: route.routeId }
                // this.routeSequence();
                this.getATMLocations();
            }
        }
    }

    reset() {
        this.model.messenger = "";
        this.model.route = "";
        this.model.kabaKey = "";
        this.model.SGKey = "";
        this.model.routeKeyId = "";
        this.model.routeSequence = [];
        this.model.allRoutes = [];
        this.vaultDateRoutes = [];
        this.model.routeStatus = "";
        // this.model.routeList = [];
    }

    // get vault date routes from routeDetails
    allRoutes() {
        this.reset();
        this.model.routeList = [];
        let date = moment(this.model.date).format('YYYY-MM-DD');
        let defer = this.$q.defer();

        this.isLoadingRoutes = true;
        this.AtmCodesManagementService.getVaultDateRoutes(this.model.branch, date)
            .then((data) => {
                if (data.results.length) {
                    this.model.routeList = data.results;
                    this.model.totalRecords = data.results.length;
                    const routes = this.mappingRouteData(data.results);
                    this.model.allRoutes = this.model.allRoutes.concat(routes);
                }
                else {
                    this.model.totalRecords = 0;
                    this.model.allRoutes = [];
                }
            })
            .then(() => {
                defer.resolve();
            })
            .catch((err) => {
                console.log(err);
                defer.reject(err);
            })
            .finally(() => {
                this.isLoadingRoutes = false;
            })
        return defer.promise;
    }

    mappingRouteData(routes) {
        return routes.map((route) => {
            return {
                Key: route.routeId + " | " + route.routeName,
                Value: route.routeId
            }
        });
    }

    routeSequence() {

        if (!this.model.route) {
            return;
        }
        this.loading = true;
        this.locationData = [];
        this.model.routeStatus = '';

        let date = moment(this.model.date).format('YYYY-MM-DD'), idx = 0;

        return this.AtmCodesManagementService.getRouteLocation(null, this.model.route.Value, this.model.branch, date)
            .then((data) => {
                this.model.routeSequence = data.results;

                if (this.model.routeSequence && this.model.routeSequence.length) {
                    this.model.routeSequence.forEach((history, index) => {
                        let nextIndex = index + 1, nextRecord = data.results[nextIndex];

                        history.seq = idx;
                        history.isMatch = 0;

                        if (data.results.length > 1 && nextRecord && nextRecord.secondaryLock && history.locationId === nextRecord.primaryLockId) {
                            history.isMatch = 1;
                            nextRecord.seq = idx;
                        }
                        else {
                            idx = idx + 1;
                        }

                        if (history.lockType === 'RTE' && history.code && history.code.isAlreadyOpened) {
                            this.reassignLockObj[history.locationId] = {};
                        }
                    })

                    this.locationData = data;
                    this.isAutoOpenATMs = data.autoOpenATMs;
                    this.model.routeSequence.map((routeData) => {
                        if (routeData.messengerId && routeData.firstName && routeData.lastName) {
                            this.model.messenger = routeData.messengerId + " | " + routeData.firstName + " " + routeData.lastName;
                        }
                        else {
                            this.model.messenger = "";
                        }
                        this.model.messengerId = routeData.messengerId;
                        this.model.kabaKey = routeData.kabaKeyId;
                        this.model.SGKey = routeData.SGKeyId;
                        this.model.routeKeyId = routeData.routeKeyId;
                        routeData.isEdit = false;
                        routeData.isSave = false;
                        routeData.atmCode = "";
                        return routeData;
                    })
                }
                else {
                    this.resetRouteDetails();
                }
            })
            .then(() => {
                if (this.atmCodesData) {
                    this.atmCodesData.redirectFromCheckoutScreen = false;
                    this.atmCodesData = this.DataCounter.setAtmCodeData();
                }
                this.getRouteStatus(this.locationData);
            })
            .catch((err) => {
                this.model.routeSequence = [];
                console.log(err);
            })
            .finally(() => {
                this.loading = false;
            })
    }

    getATMLocations() {
        if (!this.model.route) return;
        this.callOnce = true;
        clearInterval(this.apiCallTimer);
        this.routeSequence().then(() => {
            this.callOnce = false;
            this.autoOpenATMLocksProgress();
            this.checkOpenCodeProgress();
        })
    }

    resetData() {
        if (!this.model.route) {
            this.model.routeStatus = null;
            this.model.messenger = null;
            clearInterval(this.apiCallTimer);
        }
    }

    getRouteStatus(data) {
        let selectedRoute = _.find(this.model.routeList, { 'routeId': this.model.route.Value });
        // if (data.length && data.routeStatus.notPacked > 0) {
        //     this.model.isDisabled = true;
        //     return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.pending_pack', {
        //         totalCount: data.routeStatus.notPacked
        //     })
        // }
        // if (data.length && data.routeStatus.notThrown > 0) {
        //     this.model.isDisabled = true;
        //     return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.pending_throw', {
        //         totalCount: data.routeStatus.notThrown
        //     })
        // }
        if (selectedRoute.arrTime && selectedRoute.complTime) {
            this.model.isDisabled = true;
            const checkedInTime = moment(selectedRoute.complTime).format('hh:mm A');
            return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.check_in') + ' | ' + checkedInTime;
        }
        else if (selectedRoute.arriveTime && !selectedRoute.complTime) {
            this.model.isDisabled = true;
            return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.in_branch');
        }
        else if (selectedRoute.leaveTime && !selectedRoute.arriveTime) {
            this.model.isDisabled = false;
            return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.on_route');
        }
        else if (selectedRoute.checkoutTime) {
            this.model.isDisabled = false;
            const checkoutTime = moment(selectedRoute.checkoutTime).format('hh:mm A');
            return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.checked_out') + ' | ' + checkoutTime;
        }
        else if (!selectedRoute.checkoutTime) {
            this.model.isDisabled = true;
            return this.model.routeStatus = this.$translate.instant('atm_codes_mgmt.pending_checkout');
        }
        else return;
    }

    resetRouteDetails() {
        this.model.routeSequence = [];
        this.model.messenger = "";
        this.model.messengerId = "";
        this.model.kabaKey = "";
        this.model.SGKey = "";
        this.model.routeKeyId = "";
    }

    // redirect user to specific location 
    redirectToLocation(location) {
        if (location != null) {
            this.$rootScope.$broadcast('routeChange', null);
            this.Navigation.goToLocationTab(location);

        } else {
            this.error = this.$translate.instant('error.branch_mgmt.locations_not_found');
        }
    }

    editCode(data, index) {
        this.model.routeSequence[index].isEdit = true;
        this.focuseElementById(`atm-code-${index}`);
    }

    // it will create record in AtmCodesManagement table and store code to redis
    saveCode(data, index) {
        if (data.isOTCLockId) return;

        let keyId = null, OTCKeys = data.OTCKeys;

        if (OTCKeys) {
            if (data.lockType === 'LMS') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].SGKeyId : null;
            if (data.lockType === 'FLM') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].kabaKeyId : null;
            if (data.lockType === 'RTE') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].routeKeyId : null;
            if (data.lockType === 'witz') keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].witzKeyId : null;
        }

        this.model.loading = true;
        this.AtmCodesManagementService.create({
            atmCode: data.atmCode,
            locationId: data.originLockId,
            redisLocId: this.generateSerNo(data),
            performedById: this.model.loggedInUser,
            vaultDate: moment(this.model.date).format('YYYY-MM-DD'),
            messengerId: this.model.messengerId,
            routeId: this.model.route.Value,
            keyId: keyId || null,
            branchId: this.model.branch,
            isSecondaryLock: data.secondaryLock || 0,
            isOTCLockId: data.isOTCLockId || 0,
        })
            .then((data) => {
                this.model.routeSequence[index].isSave = true;
                this.currentDateTime = moment().format('DD-MM-YY hh:mm:ss A')
                if (index + 1 !== this.model.routeSequence.length) this.focuseElementById(`atm-code-${index + 1}`);
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.errorMessage += e.message + '<br/>'
                })
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    autoCommit(data, index) {
        if (this.model.routeSequence[index].atmCode) return this.saveCode(data, index);
    }

    autoOpenLocks() {
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD'),
            messengerId = this.model.messengerId,
            performedById = this.model.loggedInUser;

        this.Modal.confirmSupervisor('auto-open-locks', null, ({ modal, supId }) => {
            modal.close();
            this.Modal.autoOpenLocksModal(this.model.route.Value, this.model.branch, formattedDate, this.isAutoOpenATMs, messengerId, performedById, ({ modal }) => {
                // this.routeSequence(); // refresh data
                this.getATMLocations();
            }, ({ modal }) => {
                modal.close();
            });
        }, ({ modal }) => {
            modal.close();
        });
    }

    getLockStatus() {
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
        // this.gettingLockStatus = this.loading;
        // this.gettingLockStatus = true;

        this.Modal.confirmSupervisor('get-lock-status', null, ({ modal, supId }) => {
            modal.close();
            this.Modal.lockStatusModal(this.model.route.Value, this.model.branch, formattedDate, this.isAutoOpenATMs, this.model.messengerId, ({ modal }) => {
            }, ({ modal }) => {
                modal.close();
            });
        }, ({ modal }) => {
            // this.gettingLockStatus = false;
            modal.close();
        });
    }

    removeCharacter(message) {
        if (message) return this.AtmCodesManagementService.removeCharacter(message);
    }

    getKeys(data) {
        this.keyId = '';
        // let OTCKeys = JSON.parse(data.OTCKeys);
        let OTCKeys = data.OTCKeys;

        if (data && data.messengerId && OTCKeys) {
            if (data.lockType === 'LMS') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].SGKeyId : null;
            if (data.lockType === 'FLM') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].kabaKeyId : null;
            if (data.lockType === 'RTE') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].routeKeyId : null;
            if (data.lockType === 'witz' || data.lockType === 'TDS') return this.keyId = OTCKeys[data.OTCCompanyName] ? OTCKeys[data.OTCCompanyName].witzKeyId : null;
        }
        else this.keyId = '';
    }

    generateSerNo(data) {
        if ((data.lockType === 'LMS') && (!isNaN(data.locationId)) && data.locationId.substring(data.locationId.length - 4) != '0000') return `${data.locationId}0000`;
        else return data.locationId;
    }

    autoOpenATMLocksProgress() {
        this.openLockStack = [];
        if (!this.model.route || !this.model.messengerId) {
            clearInterval(this.apiCallTimer);
            return;
        };

        this.loadingOpenLockStats = true;
        const formattedVaultDate = moment(this.model.date).format('YYYY-MM-DD');
        this.AtmCodesManagementService.autoOpenATMLocksProgress(this.model.route.Value, formattedVaultDate, this.model.messengerId)
            .then((data) => {
                this.model.autoOpenATMLocksProgressInfo = data;
                if (this.model.autoOpenATMLocksProgressInfo.message === 'completed') {
                    clearInterval(this.apiCallTimer);
                    if (this.callOnce) this.routeSequence();
                    return;
                }
                else {
                    this.callOnce = true;
                }
                this.openLockStack.push(
                    { value: this.model.autoOpenATMLocksProgressInfo.results.totalLocationProcessed, type: 'success', message: 'Processed' },
                    { value: this.model.autoOpenATMLocksProgressInfo.results.totalInProgress, type: 'warning', message: 'Pending' }
                );
                this.totalLocations = this.model.autoOpenATMLocksProgressInfo.results.totalLocations;
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
                clearInterval(this.apiCallTimer);
            })
            .finally(() => {
                this.loadingOpenLockStats = false;
            })
    }

    checkOpenCodeProgress() {
        if (!this.model.route || !this.model.messengerId) {
            return;
        };

        let timeleft = 30;
        this.apiCallTimer = setInterval(() => {
            if (timeleft <= 0) {
                this.autoOpenATMLocksProgress();
                timeleft = 30;
            }
            timeleft -= 1;
            // console.log(`API call countdown (${timeleft})`);
        }, 1000);
    }

    reassignLock(data) {
        const { lockType, locationId, OTCCompanyName, OTCKeys } = data;
        const toKeyId = OTCKeys[OTCCompanyName].routeKeyId;

        this.model.routeSequence.forEach((location) => {
            if (location && location.lockType === 'RTE' && location.code && location.code.isAlreadyOpened) {
                this.reassignLockObj[location.locationId].isDisabled = true;
                if (location.locationId === locationId) {
                    this.reassignLockObj[locationId].loadingReassignLock = true;
                }
            }
        });

        this.AtmCodesManagementService.reassignLock(lockType, toKeyId, locationId, OTCCompanyName, this.model.loggedInUser,
                                                    this.model.route.Value, this.model.messengerId, moment(this.model.date).format('YYYY-MM-DD'), this.model.branch)
            .then((result) => {
                this.routeSequence();
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.reassignLockObj[locationId].loadingReassignLock = false;
                this.model.routeSequence.forEach((location) => {
                    if (location && location.lockType === 'RTE' && location.code && location.code.isAlreadyOpened) {
                        this.reassignLockObj[location.locationId].isDisabled = false;
                    }
                });
            })
    }
}

export default ATMCodesManagementController;


// WEBPACK FOOTER //
// ./client/app/components/atm_codes_management/atm_codes_management.controller.js